import usePermission from '../../hooks/usePermission';
import React, { useEffect, useState } from 'react';
import { BaseResponseProps, HeaderSection } from '@qlibs/react-components';
import { Button, message, Spin } from 'antd';
import { httpRequest } from '../../helpers/api';
import { AppConfigProperties } from './types/appConfig.type';
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';

const FEATURE = 'APP_CONFIG';

const TermsAndConditions = () => {
  const { isUserHasPermission } = usePermission();
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [data, setData] = useState<AppConfigProperties>({
    configId: '',
    key: '',
    value: '',
  });

  const handleSave = async () => {
    try {
      setIsLoading(true);

      await httpRequest.patch<BaseResponseProps<AppConfigProperties>>(
        '/app-configs/' + data.key,
        {
          value: data.value,
        }
      );

      message.success(`Success update terms and conditions`);
    } catch (error) {
      console.error('failed get terms and conditions', error);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    const init = async () => {
      try {
        setIsLoading(true);

        const res = await httpRequest.get<
          BaseResponseProps<AppConfigProperties>
        >('/app-configs/tnc');
        if (res && res.data.payload) {
          setData(res.data.payload);
        }
      } catch (error) {
        console.error('failed get terms and conditions', error);
      } finally {
        setIsLoading(false);
      }
    };

    init();
  }, []);

  return (
    <React.Fragment>
      <HeaderSection
        title={'Terms & Conditions'}
        rightAction={[
          isUserHasPermission([FEATURE + '.CREATE', FEATURE + '.UPDATE']) ? (
            <Button type='primary' onClick={handleSave}>
              Save
            </Button>
          ) : (
            false
          ),
        ]}
      />

      <Spin spinning={isLoading} tip='Loading data'>
        {isUserHasPermission([FEATURE + '.CREATE', FEATURE + '.UPDATE']) ? (
          <ReactQuill
            theme='snow'
            value={data.value}
            onChange={(value) => setData((current) => ({ ...current, value }))}
            placeholder='Start writing...'
            modules={TermsAndConditions.modules}
            formats={TermsAndConditions.formats}
          />
        ) : (
          <div
            style={{ marginTop: 20 }}
            dangerouslySetInnerHTML={{ __html: data.value }}
          />
        )}
      </Spin>
    </React.Fragment>
  );
};

TermsAndConditions.modules = {
  toolbar: [
    [{ header: [1, 2, false] }],
    ['bold', 'italic', 'underline', 'strike'],
    [{ list: 'ordered' }, { list: 'bullet' }],
    ['link', 'image'],
    ['clean'],
  ],
};

TermsAndConditions.formats = [
  'header',
  'bold',
  'italic',
  'underline',
  'strike',
  'list',
  'bullet',
  'link',
  'image',
];

export default TermsAndConditions;
